export default "/images/pago.svg?1ce14893a36ee4833f43aaae037248c5";